import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { backgroundColor, borders, layout, typography, space, positioning } from '../../../node_modules/@xstyled/system/dist/xstyled-system.es.js';
import { shouldForwardProp } from '../../should-forward-prop.js';
import { flexboxes } from '../../system.js';
import { Box } from '../box/Box.js';
import { Text } from '../text/Text.js';

var defaultInputStyles = {
  extra: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    height: 0;\n    width: 0;\n    margin: 0;\n    visibility: hidden;\n    &:checked + label {\n      border: 2px solid ", ";\n    }\n\n    &:checked + label:after {\n      left: calc(100% - 3px);\n      transform: translateX(-100%);\n      background: ", ";\n    }\n  "], ["\n    height: 0;\n    width: 0;\n    margin: 0;\n    visibility: hidden;\n    &:checked + label {\n      border: 2px solid ", ";\n    }\n\n    &:checked + label:after {\n      left: calc(100% - 3px);\n      transform: translateX(-100%);\n      background: ", ";\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.mofoGreen;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.mofoGreen;
  })
};
var ToggleInput = /*#__PURE__*/styled("input").withConfig({
  shouldForwardProp: function (prop, defaultValidtorFn) {
    return shouldForwardProp(prop) && defaultValidtorFn(prop);
  },
  displayName: "ToggleSwitch__ToggleInput",
  componentId: "sc-1qyxfgg-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, borders, flexboxes, layout, typography, space, positioning, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var defaultLabelStyles = {
  width: 48,
  height: 30,
  display: "block",
  borderRadius: 25,
  position: "relative",
  extra: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    cursor: pointer;\n    border: 2px solid ", ";\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 3px;\n      left: 3px;\n      width: 20px;\n      height: 20px;\n      background: ", ";\n      border-radius: 20px;\n      transition: 0.3s;\n    }\n\n    &:active:after {\n      width: 28px;\n    }\n  "], ["\n    cursor: pointer;\n    border: 2px solid ", ";\n\n    &:after {\n      content: \"\";\n      position: absolute;\n      top: 3px;\n      left: 3px;\n      width: 20px;\n      height: 20px;\n      background: ", ";\n      border-radius: 20px;\n      transition: 0.3s;\n    }\n\n    &:active:after {\n      width: 28px;\n    }\n  "])), function (_a) {
    var theme = _a.theme;
    return theme.colors.disabled;
  }, function (_a) {
    var theme = _a.theme;
    return theme.colors.disabled;
  })
};
var ToggleLabel = /*#__PURE__*/styled.label.withConfig({
  displayName: "ToggleSwitch__ToggleLabel",
  componentId: "sc-1qyxfgg-1"
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"], ["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n"])), backgroundColor, borders, flexboxes, layout, typography, space, positioning, function (_a) {
  var extra = _a.extra;
  return extra !== null && extra !== void 0 ? extra : extra;
});
var ToggleStatus = /*#__PURE__*/styled(Text).withConfig({
  displayName: "ToggleSwitch__ToggleStatus",
  componentId: "sc-1qyxfgg-2"
})(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  transition: 0.3s;\n"], ["\n  transition: 0.3s;\n"])));
var ToggleSwitch = function (_a) {
  var _b = _a.value,
    value = _b === void 0 ? false : _b,
    name = _a.name,
    rest = __rest(_a, ["value", "name"]);
  return React__default.createElement(Box, {
    maxWidth: 60
  }, React__default.createElement(Box, {
    display: "flex",
    justifyContent: "center",
    mb: "4px"
  }, React__default.createElement(ToggleInput, __assign({
    type: "checkbox",
    name: name,
    id: name,
    value: value,
    checked: value
  }, defaultInputStyles, rest)), React__default.createElement(ToggleLabel, __assign({
    htmlFor: name
  }, defaultLabelStyles))), React__default.createElement(Box, {
    display: "flex",
    justifyContent: "space-between"
  }, React__default.createElement(ToggleStatus, {
    variant: "sub",
    fontWeight: 500,
    color: !value ? "heading" : "disabled"
  }, "NAY"), React__default.createElement(ToggleStatus, {
    variant: "sub",
    fontWeight: 500,
    color: value ? "heading" : "disabled"
  }, "YAY")));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

export { ToggleInput, ToggleSwitch };
//# sourceMappingURL=ToggleSwitch.js.map
